import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import CircleInfoSolid from '@gef-ui/material-icons/CircleInfoSolid';

export const InfoCircleTooltip = ({ text, color = 'info.main', sx = {} }) => {
	return (
		<Tooltip title={text}>
			<IconButton disableRipple sx={{ color }}>
				<CircleInfoSolid sx={{ ...sx }} />
			</IconButton>
		</Tooltip>
	);
};

InfoCircleTooltip.propTypes = {
	color: PropTypes.string,
	sx: PropTypes.object,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
export default InfoCircleTooltip;
